export default "__VITE_ASSET__BA8c2lv3__"